<template>
  <el-dialog
    :title="dialogType === 'create' ? 'Tétel hozzáadása' : 'Tétel szerkesztése'"
    :append-to-body="true"
    :visible="visible"
    :close-on-click-modal="false"
    width="900px"
    @open="onOpen"
    @close="$emit('close')"
  >
    <el-form
      v-loading="loading"
      ref="form"
      :model="item"
      label-position="top"
    >
      <el-row :gutter="20">
        <el-col :span="5">
          <el-form-item
            label="Termék"
            style="margin-bottom: 0;"
          >
            <el-select
              v-model="item.product_id"
              filterable
              placeholder="Gépelj a kereséshez..."
              loading-text="Termékek betöltése..."
              style="width: 100%;"
              @change="onProductChange"
            >
              <el-option
                v-for="p in products"
                :key="p.id"
                :value="p.id"
                :label="p.name"
              />
            </el-select>
          </el-form-item>
          <el-tag
            v-if="stockLoading"
            size="small"
            type="info"
            style="margin-top: 5px; margin-bottom: 20px;"
          >
            <i class="el-icon-loading"></i> Készlet betöltése...
          </el-tag>
          <el-tag
            v-if="!stockLoading && stock"
            size="small"
            :type="stock.count > 0 ? 'success' : 'danger'"
            :loading="loading"
            style="margin-top: 5px; margin-bottom: 20px;"
          >
            {{ stock.count | bigNumber }} db készleten
          </el-tag>
        </el-col>
        <el-col :span="5">
          <el-form-item label="Kiszerelés">
            <el-select
              v-model="item.product_pack_type_id"
              v-loading="packLoading"
              :disabled="!item.product_id"
              filterable
              style="width: 100%;"
              @change="onPackChange"
            >
              <el-option
                v-for="unit in packTypes"
                :key="unit.id"
                :value="unit.id"
                :label="unit.pack_type.name"
              >
                {{ unit.pack_type.name }} ({{ unit.count_per_pack }} db / kiszerelés)
                <el-tag
                  size="mini"
                  type="info"
                  style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px; margin-top: 7px;"
                >
                  {{ unit.count || 0 }} <span v-if="unit.count_per_pack === 1">db</span><span v-else>{{ unit.pack_type.name }}</span> készleten
                </el-tag>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            label="Beszállító"
          >
            <el-select
              v-model="item.supplier_id"
              v-loading="suppliersLoading"
              :disabled="!item.product_id || !item.product_pack_type_id"
              filterable
              style="width: 100%;"
              @change="onSupplierChange"
            >
              <el-option
                v-for="s in suppliers"
                :key="s.id"
                :value="s.id"
                :label="s.company.name"
              >
                #{{ s.id }} {{ s.company.name }}
                <el-tag
                  size="mini"
                  type="info"
                  style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px; margin-top: 7px;"
                >
                  {{ s.count || 0 }} <span v-if="selectedPackType.count_per_pack === 1">db</span><span v-else>{{ selectedPackType.pack_type.name }}</span> készleten
                </el-tag>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="Szav. idő">
            <el-select
              v-model="item.expiration_date"
              clearable
            >
              <el-option
                v-for="expiration in expirations"
                :key="expiration.expiration_date"
                :value="expiration.expiration_date"
                :label="$options.filters.date(expiration.expiration_date)"
              >
                {{ expiration.expiration_date | date }}
                <span
                  v-if="expiration.count"
                  style="float: right; color: #8492a6; font-size: 13px; margin-left: 20px;"
                >
                  <el-tag
                    size="mini"
                    type="info"
                  >
                    {{ expiration.count }} {{ selectedPackType.pack_type.name }} készleten
                  </el-tag>
                </span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="Mennyiség">
            <el-input-localized-numeric
              v-model="item.count"
            >
            </el-input-localized-numeric>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Megjegyzés">
        <el-input
          v-model="item.comment"
          type="textarea"
          :rows="3"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="store">{{ dialogType === 'create' ? 'Hozzáadás' : 'Mentés'}}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: ['visible', 'currency', 'defaultItem', 'storageId', 'availableProducts'],
  data() {
    return {
      item: {},
      selectedPackType: {},
      selectedSupplier: {},
      dialogType: 'create',
      productsLoading: false,
      suppliersLoading: false,
      servicesLoading: false,
      stockLoading: false,
      packLoading: false,
      priceLoading: false,
      loading: false,
      originalUnitPrice: 0,
      products: [],
      suppliers: [],
      packTypes: [],
      expirations: [],
      stock: null,
    };
  },
  methods: {
    async store() {
      this.$emit('change', this.item);
      this.$emit('close');
    },
    async onPackChange(packTypeId) {
      this.$set(this.item, 'supplier_id', null);
      this.$set(this.item, 'supplier_name', null);
      this.$set(this.item, 'expiration_date', null);
      this.$set(this.item, 'product_pack_type_id', packTypeId);
      this.selectedPackType = this.stock.packs.find(packType => packType.id == packTypeId);
      this.$set(this.item, 'pack_type_name', this.selectedPackType.pack_type.name);
      this.$set(this.item, 'count_per_pack', this.selectedPackType.count_per_pack);
      this.suppliers = this.selectedPackType.suppliers;
    },
    async onProductChange(value) {
      const selectedProduct = this.availableProducts.find(p => p.product_id === value);
      if (selectedProduct) {
        this.$set(this.item, 'unit_price', selectedProduct.unit_price);
        this.$set(this.item, 'net_price', selectedProduct.net_price);
      }
      await this.setStock()
    },
    async setProductVat() {
      this.vatLoading = true;
      const vat = await axios.get(`api/vats/product/${this.item.product_id}`);
      this.$set(this.item, 'vat', vat);
      this.vatLoading = false;
    },
    async onSupplierChange(supplierId) {
      this.$set(this.item, 'supplier_id', supplierId);
      this.selectedSupplier = this.selectedPackType.suppliers.find(s => s.id == supplierId);
      this.$set(this.item, 'supplier_name', this.selectedSupplier.company.name);
      this.$set(this.item, 'pack_type_name', this.selectedPackType.pack_type.name);
      this.$set(this.item, 'count_per_pack', this.selectedPackType.count_per_pack);
      this.expirations = this.selectedSupplier.expirations;
    },
    async setStock() {
      this.stockLoading = true;
      this.stock = await axios.get(`api/products/${this.item.product_id}/storage/${this.storageId}`);
      this.packTypes = this.stock.packs;
      if (this.item.product_pack_type_id) {
        this.selectedPackType = this.packTypes.find(pt => pt.id === this.item.product_pack_type_id);
        this.suppliers = this.selectedPackType && this.selectedPackType.suppliers || [];
        if (this.item.supplier_id) {
          this.selectedSupplier = this.suppliers.find(s => s.id === this.item.supplier_id);
          this.expirations = this.selectedSupplier && this.selectedSupplier.expirations || [];
        }
      }
      this.products = [{ id: this.stock.id, name: this.stock.name }];
      this.$set(this.item, 'name', this.stock.name);
      this.stockLoading = false;
    },
    async onOpen() {
      this.loading = true;
      this.stock = null;
      this.suppliers = [];
      this.packTypes = [];
      this.expirations = [];
      this.selectedPackType = {};
      this.selectedSupplier = {};
      this.setItem();
      if (this.item.key || this.item.id) {
        this.dialogType = 'update';
      } else {
        this.dialogType = 'create';
      }
      const pallets = await axios.get(`api/search/products?is_pallet=1`);
      const uniqueProducts = [...new Set(this.availableProducts.map(item => item.product_id))].map(id => ({
        ...this.availableProducts.find(p => p.product_id === id),
        id,
      }));
      this.products = [
        ...uniqueProducts,
        ...pallets
      ];
      // if (this.item.supplier_id) {
      //   if (this.item.supplier_name) {
      //     this.suppliers = [{ id: this.item.supplier_id, name: this.item.supplier_name }];
      //   } else {
      //     this.suppliers = await axios.get(`api/search/suppliers/${this.item.product_id}`);
      //   }
      // }
      if (this.item.product_id) {
        await this.setStock();
      }
      this.loading = false;
    },
    setItem() {
      this.item = { ...this.defaultItem };
    },
  },
};
</script>
